// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aDEP","colBig":"styles_colBig__pK6Qn","colSmall":"styles_colSmall__2bHqi"};